import Slider from "components/DesignSystem/Slider/Slider";
import { Task1120SliderContent } from "./Task1120SliderContent";
import { Task1120Tracker } from "types/Models/TaskTracker";

export const Task1120Slider = ({
  rowData,
  isOpen,
  onClose,
  defaultTab = "DETAILS",
}: {
  rowData?: Task1120Tracker;
  isOpen: boolean;
  onClose: () => void;
  defaultTab?: "DETAILS" | "CHAT" | "REVIEW";
}) => {
  return (
    <Slider.Root open={isOpen} onOpenChange={onClose}>
      <Slider.Content open={isOpen}>
        {rowData && (
          <Task1120SliderContent defaultTab={defaultTab} rowData={rowData} />
        )}
      </Slider.Content>
    </Slider.Root>
  );
};
